export default __webpack_public_path__ + "static/media/logo.f52a407d.svg";